<app-loading *ngIf="contentReady"></app-loading>

<section class="bb-page" *ngIf="!contentReady">
  <div class="bb-page-shell">

    <!-- Header & Actions -->
    <div class="bb-page-header">
      <div class="bb-page-title-block">
        <span class="bb-eyebrow">{{ 'Bundle Management' | transloco }}</span>
        <h2 class="bb-page-title">{{ 'Bundle Management' | transloco }}</h2>
      </div>

      <div class="bb-header-actions">
        <button routerLink="/addbundle" class="bb-btn bb-btn-primary bb-btn-wide">
          {{ "Add Bundle" | transloco }}
        </button>
      </div>
    </div>

    <!-- Stats Cards -->
    <div class="row g-3 bb-mb-16">

      <!-- Total Bundles -->
      <div class="col-lg-4 col-md-6 col-sm-12">
        <div class="bb-card bb-p-20 bb-h-100">
          <div class="bb-text-muted bb-font-semibold bb-mb-8">
            {{ "Total Bundles" | transloco }}
          </div>
          <h3 class="bb-m-0 bb-text-blue bb-font-bold">
            {{ totalBundles }}
          </h3>
        </div>
      </div>

      <!-- Lowest Price -->
      <div class="col-lg-4 col-md-6 col-sm-12">
        <div class="bb-card bb-p-20 bb-h-100">
          <div class="bb-text-muted bb-font-semibold bb-mb-8">
            {{ "lowestPrice" | transloco }}
          </div>
          <h3 class="bb-m-0 bb-text-success bb-font-bold">
            {{ lowestPrice | number:'1.0-0' }}
            <small class="bb-text-muted bb-font-medium">{{ "egp" | transloco }}</small>
          </h3>
        </div>
      </div>

      <!-- Highest Price -->
      <div class="col-lg-4 col-md-6 col-sm-12">
        <div class="bb-card bb-p-20 bb-h-100">
          <div class="bb-text-muted bb-font-semibold bb-mb-8">
            {{ "Highest Price" | transloco }}
          </div>
          <h3 class="bb-m-0 bb-text-danger bb-font-bold">
            {{ highestPrice | number:'1.0-0' }}
            <small class="bb-text-muted bb-font-medium">{{ "egp" | transloco }}</small>
          </h3>
        </div>
      </div>

    </div>

    <!-- Search Bar -->
    <!--
    <div class="bb-filter-card">
      <div class="bb-search-full">
        <div class="bb-input-icon-wrap">
          <input
            type="text"
            class="bb-input bb-input-lg"
            placeholder="{{ 'Search bundles...' | transloco }}"
            (keyup)="applyFilter($event)"
          />
        </div>
      </div>
    </div>
    -->

    <!-- Bundles Table -->
    <div class="bb-table-card bb-p-16">
      <div class="bb-table-scroll">
        <table class="bb-table table table-custom">
          <thead>
            <tr>
              <th>{{ 'Name' | transloco }}</th>
              <th>{{ 'NameAr' | transloco }}</th>
              <th>{{ 'products' | transloco }}</th>
              <th>{{ 'price' | transloco }}</th>
              <th>{{ 'Affiliation' | transloco }}</th>
              <th>{{ 'Page A' | transloco }}</th>
              <th>{{ 'B' | transloco }}</th>
              <th>{{ 'C' | transloco }}</th>
              <th class="bb-actions-th">{{ 'Delete' | transloco }}</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let el of dataSource.data">

              <!-- Name EN + Image -->
              <td>
                <div class="bb-inline-flex bb-items-center bb-gap-12">
                  <div *ngIf="el.image" class="bb-product-img-box">
                    <img [src]="fixImage(el.image)" />
                  </div>

                  <strong class="bb-text-navy">
                    {{ el.name_en || '—' }}
                  </strong>
                </div>
              </td>

              <!-- Name AR -->
              <td>{{ el.name_ar || '—' }}</td>

              <!-- Components List -->
              <td>
                <div *ngIf="el.items?.length > 0" class="bb-inline-flex bb-items-center bb-wrap bb-gap-4">
                  <span *ngFor="let item of el.items; let last = last" class="bb-badge bb-badge-soft-blue">
                    {{ isAr ? item.stock?.name_ar : item.stock?.name_en }}
                    <strong>x{{ item.quantity }}</strong>
                    <span *ngIf="!last">,</span>
                  </span>
                </div>

                <span *ngIf="!el.items || el.items.length === 0" class="bb-text-muted bb-font-semibold">
                  {{ 'No Items' | transloco }}
                </span>
              </td>

              <!-- Price -->
              <td>
                <strong class="bb-price">
                  {{ el.price | number:'1.0-0' }}
                  {{ "egp" | transloco }}
                </strong>
              </td>

              <!-- Affiliation Price -->
              <td>{{ el.affiliationprice | number:'1.0-0' }} {{ "egp" | transloco }}</td>

              <!-- Price A -->
              <td>{{ el.pricea | number:'1.0-0' }} {{ "egp" | transloco }}</td>

              <!-- Price B -->
              <td>{{ el.priceb | number:'1.0-0' }} {{ "egp" | transloco }}</td>

              <!-- Price C -->
              <td>{{ el.pricec | number:'1.0-0' }} {{ "egp" | transloco }}</td>

              <!-- Actions -->
              <td class="bb-actions-td">
                <button
                  class="bb-icon-btn bb-icon-btn-danger"
                  (click)="delete(el.id)"
                  title="{{ 'Delete' | transloco }}"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" />
                  </svg>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Paginator -->
      <mat-paginator
        *ngIf="!noData"
        [length]="totalItems"
        [pageSize]="perPage"
        [pageIndex]="page - 1"
        (page)="onPaginateChange($event)"
        class="bb-paginator"
      >
      </mat-paginator>

      <!-- No Data State -->
      <div *ngIf="noData" class="bb-empty-state">
        <app-nodata></app-nodata>
      </div>
    </div>

  </div>
</section>